import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import { UserRole } from '@app/models';
import { isNotEmpty } from '@util';
import * as R from 'ramda';

/**
 * This directive should be used when you need to check if the current user belongs to any of the provided user roles
 * as input.
 * The user roles are provided as input to the directive in the format of array of ids of the {@link UserRole} enum.
 * Example: *pcsShowIfRole="['P', 'i']" checks if the current user is an Admin or Integration Platform user.
 */
@Directive({
  selector: '[pcsShowIfRole]'
})
export class ShowIfRoleDirective {

  constructor(private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService) {
  }

  @Input()
  set pcsShowIfRole(roles: UserRole[]) {
    if (this.isUserOfRole(roles)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  isUserOfRole(roles: UserRole[]) {
    return isNotEmpty(roles) && R.any((role: UserRole) => R.cond([
      [R.equals(UserRole.IntegrationPlatformUser), R.always(this.userService.isIntegrationPlatform())],
      [R.equals(UserRole.Admin), R.always(this.userService.isAdmin())],
    ])(role))(roles);
  }

}
